import { render, staticRenderFns } from "./recognized_face.vue?vue&type=template&id=838e2bc4"
import script from "./recognized_face.vue?vue&type=script&lang=js"
export * from "./recognized_face.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports